import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";
// import way from '../vue_fun.js'
// Vue.use(way)
import VueEasytable from "vue-easytable";
// 引入样式
import "vue-easytable/libs/theme-default/index.css";
import "vue-easytable/libs/theme-default/ve-pagination.css";
import myUpload from "./components/myUpload/my-upload.vue";
import cjUpload from "./components/cj-upload.vue";
Vue.component("myUpload", myUpload);
Vue.component("cjUpload", cjUpload);
import './utils/directives.js';
Vue.use(VueEasytable);
import { VeLocale } from "vue-easytable";
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.prototype.$veLocale = VeLocale;
router.beforeEach((to, from, next) => {
  //debugger
  if (to.path === "/doLogin") {
    next();
  } else {
    let userid = localStorage.getItem("userid");
    if (userid) {
      next();
    } else {
      next("/doLogin");
    }
  }
});
// console.log(way)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
//import fileDownload from 'js-file-download';
// 先将文件地址转换为文件流,url文件地址,在用fileDownload进行下载
// let newUrl = url.replace("http://192.168.6.1009", "/api");
// axios({
//   method: "get",
//   url: newUrl,//
//   responseType: "blob",
// }).then((res) => {
//   fileDownload(res.data, name);
// });
